import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { get } from 'lodash';
import { SanitizeHtml } from '@bd/bdcore-utilities';

import { colors } from '../../styles';
import AccordionToggle from '../../components/AccordionToggle';

const styles = css`
  @media(min-width: 992px) {
    padding: 50px 20px;
  }
  .HomeFeatures_list {
    font-weight: 300;
    font-size: 15px;
    color: ${colors.color3};
    letter-spacing: 0;
    line-height: 28px;
    @media(min-width: 992px) {
      font-size: 17px;
      color: ${colors.text};
      line-height: 30px;
    }
    ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      list-style: none;
      padding: 0;
      margin: 0;
      li {
        margin: 0 0 15px 20px;
        position: relative;
        width: 100%;
        @media(min-width: 576px) {
          width: 45%;
        }
        @media(min-width: 992px) {
          margin: 0 0 20px 30px;
          width: calc(50% - 30px);
        }
        &::before {
          content: '';
          width: 10px;
          height: 10px;
          background-color: #808080;
          position: absolute;
          left: -21px;
          top: 10px;
          @media(min-width: 992px) {
            width: 12px;
            height: 12px;
          }
        }
      }
    }
  }
`;

function HomeFeatures({ home }) {
  return (
    <div className={styles}>
      <AccordionToggle
        openOnId="features"
        button={({ contentVisible }) => (
          <div className="">
            <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Home Features</h3>
          </div>
        )}
      >
        <div className="container-fluid">
          <div dangerouslySetInnerHTML={SanitizeHtml(get(home, 'features'))} className="HomeFeatures_list" />
        </div>
      </AccordionToggle>
    </div>
  );
}

HomeFeatures.propTypes = {
  home: PropTypes.object.isRequired,
};

export default HomeFeatures;



// WEBPACK FOOTER //
// ./src/pages/HomeDetail/HomeFeatures.js